const parseFlag = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  return ['1', 'true', 'yes', 'on'].includes(String(value).trim().toLowerCase());
};

export const ENABLE_CRYPTO_PAYMENTS = parseFlag(process.env.REACT_APP_ENABLE_CRYPTO_PAYMENTS, false);
export const ENABLE_CRYPTO_WITHDRAWALS = parseFlag(process.env.REACT_APP_ENABLE_CRYPTO_WITHDRAWALS, false);
